<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XIsMYe/media/FC-9781645365785.jpg?1697494221109" alt="This image is the cover for the book Love Under Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love Under Fire
      </h1>
      <p class="bookDescription body article font2">
        <p style="text-align: center;">“<em>Love Under Fire</em> is dedicated to the women who have inspired me and whom I have known and loved and in a few cases loved too much. Their number is many, and I thank all in memory of their timeless appreciation and remembrance – the cornerstones of immortality for all.</p><p style="text-align: center;"><br/></p><p style="text-align: center;">Their combined life stories have emboldened the world and enriched the uniqueness of all our individual lives, journeys, and endeavors.”</p><p style="text-align: center;"><br/></p><p style="text-align: center;">The Way of the World…</p><p style="text-align: center;">What Loss</p><p style="text-align: center;">My heart is strong enough</p><p style="text-align: center;">to give…</p><p style="text-align: center;">But not strong enough</p><p style="text-align: center;">To give away.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Jane Burrell
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Amanda Burrell was born in Sleaford, England. She has spent the last 30 years traveling the world while working within the fields of education and communication. She now spends her time between Northern Ireland and Cyprus, where she lives with her husband, David.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b0d6885